<div class="agent-selection-dialog">
  <div class="p-4">
    <h4 class="text-lg font-semibold text-900 mb-4">{{ 'chat.threads.select-agent-for-new-thread' | translate }}</h4>
    
    @if ((availableAgents$ | async)?.length === 0) {
      <div class="text-center p-4">
        <i class="pi pi-exclamation-triangle text-4xl text-orange-500 mb-3 block"></i>
        <p class="text-sm text-600 mb-0">{{ 'chat.threads.no-agents-available' | translate }}</p>
      </div>
    } @else {
      <div class="grid gap-3">
        @for (agent of availableAgents$ | async; track agent.id) {
          <div class="col-12">
            <div
              class="p-3 border-1 surface-border border-round cursor-pointer transition-all transition-duration-200 hover:border-primary-200 hover:bg-primary-50"
              [ngClass]="{
                'border-primary bg-primary-50': selectedAgent?.id === agent.id,
                'opacity-50 cursor-not-allowed': !agent.isAvailable
              }"
              (click)="selectAgent(agent)"
            >
              <div class="flex align-items-center gap-3">
                <i [class]="getAgentIcon(agent)" class="text-primary text-xl"></i>
                <div class="flex-1">
                  <div class="font-medium text-sm text-900">{{ agent.name }}</div>
                  <div class="text-xs text-600 mt-1">{{ agent.description }}</div>
                  <div class="text-xs text-500 mt-1">
                    {{ 'chat.agents.category.' + agent.category | translate }}
                  </div>
                </div>
                @if (selectedAgent?.id === agent.id) {
                  <i class="pi pi-check text-primary"></i>
                }
              </div>
            </div>
          </div>
        }
      </div>
    }
  </div>
  
  <div class="flex justify-content-end gap-2 p-4 border-top-1 surface-border">
    <p-button
      [label]="'common.cancel' | translate"
      severity="secondary"
      (onClick)="cancel()"
      [text]="true">
    </p-button>
    <p-button
      [label]="'common.create' | translate"
      (onClick)="confirm()"
      [disabled]="!selectedAgent">
    </p-button>
  </div>
</div>